<template>
  <div>
    <div class="has-text-centered pt-4 pb-6">
      <!-- <p class="title">Experimente Grátis por 3 meses</p> -->
      <p class="title">Agenda Online para Consultório</p>
      <p class="subtitle">
        Agende com facilidade, reduza faltas e economize tempo com nosso sistema
        de agenda online!
      </p>
    </div>
    <div class="columns is-variable is-1 mb-0">
      <div class="column is-7">
        <div class="box is-radiusless pt-6 pb-4">
          <DoctorForm />
        </div>
      </div>
      <div class="column">
        <img src="@/assets/account_try_bg.png" alt="Max Agenda - Try" />
      </div>
    </div>
  </div>
</template>
<script>
import DoctorForm from "./DoctorForm.vue";
export default {
  name: "DoctorRegister",
  components: {
    DoctorForm,
  },
  data() {
    return {};
  },
  computed: {},
  created() {},
  methods: {},
};
</script>

